import type { Client } from '@efdigital/ll-addon-data';
import { debounce } from '@efdigital/ll-addon-ui/modifiers/debounce';
import {
  EditRecord,
  initialState,
} from '@efdigital/ll-admin-v2/components/edit-record.gts';
import { type EditRecordSignature } from '@efdigital/ll-admin-v2/components/edit-record-base.gts';
import { InputDateTime } from '@efdigital/ll-admin-v2/components/input-date.gts';
import eq from '@efdigital/ll-admin-v2/helpers/eq.ts';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

export class EditClient extends Component<EditRecordSignature<Client>> {
  setTitle = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.args.item.title = target.value;
  };

  setSubscription = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    this.args.item.subscription = target.value;
  };

  setStarts = (value: string) => {
    this.args.item.starts = value;
  };

  setExpires = (value: string) => {
    this.args.item.expires = value;
  };

  <template>
    <EditRecord
      @editLabel="Edit Client"
      @item={{@item}}
      @context={{@context}}
      @buttonSize="btn-md"
      @initialState={{initialState @item}}
      @maxDepth={{1}}
    >
      <:form as |uniqueId isReadOnly|>
        <fieldset disabled={{isReadOnly}} class="mb-4">
          <legend class="gud-eyebrow">Identity</legend>

          <div class="mb-3">
            <label for="{{uniqueId}}-title" class="form-control-label required">
              Title
            </label>
            <input
              type="text"
              id="{{uniqueId}}-title"
              class="form-control"
              value={{@item.title}}
              {{debounce this.setTitle}}
              placeholder="Client name"
              required
            />
          </div>

          <div class="mb-3">
            <label
              for="{{uniqueId}}-subscription"
              class="form-control-label required"
            >
              Subscription
            </label>
            <select
              id="{{uniqueId}}-subscription"
              class="form-select"
              {{on "change" this.setSubscription}}
              required
            >
              <option value="trial" selected={{eq @item.subscription "trial"}}>
                Trial
              </option>
              <option
                value="selected"
                selected={{eq @item.subscription "selected"}}
              >
                Selected Content
              </option>
              <option value="full" selected={{eq @item.subscription "full"}}>
                Standard
              </option>
              <option
                value="premium"
                selected={{eq @item.subscription "premium"}}
              >
                Premium
              </option>
            </select>
          </div>
        </fieldset>

        <fieldset disabled={{isReadOnly}} class="mb-4">
          <legend class="gud-eyebrow">Validity</legend>

          <div class="mb-3">
            <label for="{{uniqueId}}-starts" class="form-control-label">
              Starts
            </label>
            <InputDateTime
              id="{{uniqueId}}-starts"
              class="form-control"
              @value={{@item.starts}}
              @onChange={{this.setStarts}}
            />
          </div>

          <div class="mb-3">
            <label
              for="{{uniqueId}}-expires"
              class="form-control-label required"
            >
              Expires
            </label>
            <InputDateTime
              id="{{uniqueId}}-expires"
              class="form-control"
              @value={{@item.expires}}
              @onChange={{this.setExpires}}
              required
            />
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
